/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ApClassSignupFull,
  ApClassSignupFullOptional,
  ApClassSignupFullMetaI,
  ApClassSignupFullTrackedI,
} from "./ap-class-signup-full";
import {
  ApClassSignupFullTracked,
  ApClassSignupFullMeta,
} from "./ap-class-signup-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionFull,
  BalanceTransactionFullOptional,
  BalanceTransactionFullMetaI,
  BalanceTransactionFullTrackedI,
} from "./balance-transaction-full";
import {
  BalanceTransactionFullTracked,
  BalanceTransactionFullMeta,
} from "./balance-transaction-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CardFull,
  CardFullOptional,
  CardFullMetaI,
  CardFullTrackedI,
} from "./card-full";
import { CardFullTracked, CardFullMeta } from "./card-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverFull,
  DamageWaiverFullOptional,
  DamageWaiverFullMetaI,
  DamageWaiverFullTrackedI,
} from "./damage-waiver-full";
import {
  DamageWaiverFullTracked,
  DamageWaiverFullMeta,
} from "./damage-waiver-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFull,
  DonationFullOptional,
  DonationFullMetaI,
  DonationFullTrackedI,
} from "./donation-full";
import { DonationFullTracked, DonationFullMeta } from "./donation-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  GuestPrivsFull,
  GuestPrivsFullOptional,
  GuestPrivsFullMetaI,
  GuestPrivsFullTrackedI,
} from "./guest-privs-full";
import { GuestPrivsFullTracked, GuestPrivsFullMeta } from "./guest-privs-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceRef,
  ItemInstanceRefOptional,
  ItemInstanceRefMetaI,
  ItemInstanceRefTrackedI,
} from "./item-instance-ref";
import {
  ItemInstanceRefTracked,
  ItemInstanceRefMeta,
} from "./item-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceStockChangeBase,
  ItemInstanceStockChangeBaseOptional,
  ItemInstanceStockChangeBaseMetaI,
  ItemInstanceStockChangeBaseTrackedI,
} from "./item-instance-stock-change-base";
import {
  ItemInstanceStockChangeBaseTracked,
  ItemInstanceStockChangeBaseMeta,
} from "./item-instance-stock-change-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemBase,
  LineItemBaseOptional,
  LineItemBaseMetaI,
  LineItemBaseTrackedI,
} from "./line-item-base";
import { LineItemBaseTracked, LineItemBaseMeta } from "./line-item-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemDiscountInstanceBase,
  LineItemDiscountInstanceBaseOptional,
  LineItemDiscountInstanceBaseMetaI,
  LineItemDiscountInstanceBaseTrackedI,
} from "./line-item-discount-instance-base";
import {
  LineItemDiscountInstanceBaseTracked,
  LineItemDiscountInstanceBaseMeta,
} from "./line-item-discount-instance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRef,
  LineItemRefOptional,
  LineItemRefMetaI,
  LineItemRefTrackedI,
} from "./line-item-ref";
import { LineItemRefTracked, LineItemRefMeta } from "./line-item-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRefundBase,
  LineItemRefundBaseOptional,
  LineItemRefundBaseMetaI,
  LineItemRefundBaseTrackedI,
} from "./line-item-refund-base";
import {
  LineItemRefundBaseTracked,
  LineItemRefundBaseMeta,
} from "./line-item-refund-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemTaxBase,
  LineItemTaxBaseOptional,
  LineItemTaxBaseMetaI,
  LineItemTaxBaseTrackedI,
} from "./line-item-tax-base";
import {
  LineItemTaxBaseTracked,
  LineItemTaxBaseMeta,
} from "./line-item-tax-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemWithExpiresOnRef,
  LineItemWithExpiresOnRefOptional,
  LineItemWithExpiresOnRefMetaI,
  LineItemWithExpiresOnRefTrackedI,
} from "./line-item-with-expires-on-ref";
import {
  LineItemWithExpiresOnRefTracked,
  LineItemWithExpiresOnRefMeta,
} from "./line-item-with-expires-on-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipFull,
  MembershipFullOptional,
  MembershipFullMetaI,
  MembershipFullTrackedI,
} from "./membership-full";
import { MembershipFullTracked, MembershipFullMeta } from "./membership-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonSubscriptionRef,
  PersonSubscriptionRefOptional,
  PersonSubscriptionRefMetaI,
  PersonSubscriptionRefTrackedI,
} from "./person-subscription-ref";
import {
  PersonSubscriptionRefTracked,
  PersonSubscriptionRefMeta,
} from "./person-subscription-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryRef,
  PurchaseDeliveryRefOptional,
  PurchaseDeliveryRefMetaI,
  PurchaseDeliveryRefTrackedI,
} from "./purchase-delivery-ref";
import {
  PurchaseDeliveryRefTracked,
  PurchaseDeliveryRefMeta,
} from "./purchase-delivery-ref";

/**
 *
 * @export
 * @interface LineItemFull
 */
export interface LineItemFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  isNew?: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemFull
   */
  amountBaseCents?: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemFull
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemFull
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemFull
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemFull
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemFull
   */
  squareLineItemUid?: string;
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemFull
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemFull
   */
  referenceId?: string;
  /**
   *
   * @type {LineItemRef}
   * @memberof LineItemFull
   */
  parentItemId?: LineItemRefOptional;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof LineItemFull
   */
  itemInstanceId?: ItemInstanceRefOptional;
  /**
   *
   * @type {PersonSubscriptionRef}
   * @memberof LineItemFull
   */
  subscriptionId?: PersonSubscriptionRefOptional;
  /**
   *
   * @type {ApClassSignupFull}
   * @memberof LineItemFull
   */
  classSignup?: ApClassSignupFullOptional;
  /**
   *
   * @type {MembershipFull}
   * @memberof LineItemFull
   */
  membership?: MembershipFullOptional;
  /**
   *
   * @type {DonationFull}
   * @memberof LineItemFull
   */
  donation?: DonationFullOptional;
  /**
   *
   * @type {CardFull}
   * @memberof LineItemFull
   */
  card?: CardFullOptional;
  /**
   *
   * @type {BalanceTransactionFull}
   * @memberof LineItemFull
   */
  giftCard?: BalanceTransactionFullOptional;
  /**
   *
   * @type {GuestPrivsFull}
   * @memberof LineItemFull
   */
  guestPrivs?: GuestPrivsFullOptional;
  /**
   *
   * @type {DamageWaiverFull}
   * @memberof LineItemFull
   */
  damageWaiver?: DamageWaiverFullOptional;
  /**
   *
   * @type {ItemInstanceStockChangeBase}
   * @memberof LineItemFull
   */
  stockChange?: ItemInstanceStockChangeBaseOptional;
  /**
   *
   * @type {PurchaseDeliveryRef}
   * @memberof LineItemFull
   */
  purchaseDelivery?: PurchaseDeliveryRefOptional;
  /**
   *
   * @type {Array<LineItemTaxBase>}
   * @memberof LineItemFull
   */
  appliedTaxes?: LineItemTaxBaseOptional[];
  /**
   *
   * @type {Array<LineItemDiscountInstanceBase>}
   * @memberof LineItemFull
   */
  discounts?: LineItemDiscountInstanceBaseOptional[];
  /**
   *
   * @type {Array<LineItemRefundBase>}
   * @memberof LineItemFull
   */
  refunds?: LineItemRefundBaseOptional[];
}

export interface LineItemFull
  extends
    LineItemFullOptional,
    Deletable,
    LineItemBase,
    LineItemWithExpiresOnRef {
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  isNew?: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemFull
   */
  amountBaseCents: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemFull
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemFull
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemFull
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemFull
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemFull
   */
  squareLineItemUid?: string;
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemFull
   */
  expiresOn?: Date;
  /**
   *
   * @type {number}
   * @memberof LineItemFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof LineItemFull
   */
  referenceId?: string;
  /**
   *
   * @type {LineItemRef}
   * @memberof LineItemFull
   */
  parentItemId?: LineItemRef;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof LineItemFull
   */
  itemInstanceId: ItemInstanceRef;
  /**
   *
   * @type {PersonSubscriptionRef}
   * @memberof LineItemFull
   */
  subscriptionId?: PersonSubscriptionRef;
  /**
   *
   * @type {ApClassSignupFull}
   * @memberof LineItemFull
   */
  classSignup?: ApClassSignupFull;
  /**
   *
   * @type {MembershipFull}
   * @memberof LineItemFull
   */
  membership?: MembershipFull;
  /**
   *
   * @type {DonationFull}
   * @memberof LineItemFull
   */
  donation?: DonationFull;
  /**
   *
   * @type {CardFull}
   * @memberof LineItemFull
   */
  card?: CardFull;
  /**
   *
   * @type {BalanceTransactionFull}
   * @memberof LineItemFull
   */
  giftCard?: BalanceTransactionFull;
  /**
   *
   * @type {GuestPrivsFull}
   * @memberof LineItemFull
   */
  guestPrivs?: GuestPrivsFull;
  /**
   *
   * @type {DamageWaiverFull}
   * @memberof LineItemFull
   */
  damageWaiver?: DamageWaiverFull;
  /**
   *
   * @type {ItemInstanceStockChangeBase}
   * @memberof LineItemFull
   */
  stockChange?: ItemInstanceStockChangeBase;
  /**
   *
   * @type {PurchaseDeliveryRef}
   * @memberof LineItemFull
   */
  purchaseDelivery?: PurchaseDeliveryRef;
  /**
   *
   * @type {Array<LineItemTaxBase>}
   * @memberof LineItemFull
   */
  appliedTaxes?: LineItemTaxBase[];
  /**
   *
   * @type {Array<LineItemDiscountInstanceBase>}
   * @memberof LineItemFull
   */
  discounts?: LineItemDiscountInstanceBase[];
  /**
   *
   * @type {Array<LineItemRefundBase>}
   * @memberof LineItemFull
   */
  refunds?: LineItemRefundBase[];
}

export interface LineItemFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemFull
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemFull
   */
  amountSpecifiedCents?: number;
  amountSpecifiedCentsIsSet: boolean;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemFull
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemFull
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemFull
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemFull
   */
  autoAdded?: boolean;
  autoAddedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemFull
   */
  squareLineItemUid?: string;
  squareLineItemUidIsSet: boolean;
  /**
   * Timestamp when this line item expires and should be automatically removed
   * @type {string}
   * @memberof LineItemFull
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemFull
   */
  referenceId?: string;
  referenceIdIsSet: boolean;
  /**
   *
   * @type {LineItemRef}
   * @memberof LineItemFull
   */
  parentItemId?: LineItemRefTrackedI;
  parentItemIdIsSet: boolean;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof LineItemFull
   */
  itemInstanceId?: ItemInstanceRefTrackedI;
  itemInstanceIdIsSet: boolean;
  /**
   *
   * @type {PersonSubscriptionRef}
   * @memberof LineItemFull
   */
  subscriptionId?: PersonSubscriptionRefTrackedI;
  subscriptionIdIsSet: boolean;
  /**
   *
   * @type {ApClassSignupFull}
   * @memberof LineItemFull
   */
  classSignup?: ApClassSignupFullTrackedI;
  classSignupIsSet: boolean;
  /**
   *
   * @type {MembershipFull}
   * @memberof LineItemFull
   */
  membership?: MembershipFullTrackedI;
  membershipIsSet: boolean;
  /**
   *
   * @type {DonationFull}
   * @memberof LineItemFull
   */
  donation?: DonationFullTrackedI;
  donationIsSet: boolean;
  /**
   *
   * @type {CardFull}
   * @memberof LineItemFull
   */
  card?: CardFullTrackedI;
  cardIsSet: boolean;
  /**
   *
   * @type {BalanceTransactionFull}
   * @memberof LineItemFull
   */
  giftCard?: BalanceTransactionFullTrackedI;
  giftCardIsSet: boolean;
  /**
   *
   * @type {GuestPrivsFull}
   * @memberof LineItemFull
   */
  guestPrivs?: GuestPrivsFullTrackedI;
  guestPrivsIsSet: boolean;
  /**
   *
   * @type {DamageWaiverFull}
   * @memberof LineItemFull
   */
  damageWaiver?: DamageWaiverFullTrackedI;
  damageWaiverIsSet: boolean;
  /**
   *
   * @type {ItemInstanceStockChangeBase}
   * @memberof LineItemFull
   */
  stockChange?: ItemInstanceStockChangeBaseTrackedI;
  stockChangeIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryRef}
   * @memberof LineItemFull
   */
  purchaseDelivery?: PurchaseDeliveryRefTrackedI;
  purchaseDeliveryIsSet: boolean;
  /**
   *
   * @type {Array<LineItemTaxBase>}
   * @memberof LineItemFull
   */
  appliedTaxes?: LineItemTaxBaseTrackedI[];
  appliedTaxesIsSet: boolean;
  /**
   *
   * @type {Array<LineItemDiscountInstanceBase>}
   * @memberof LineItemFull
   */
  discounts?: LineItemDiscountInstanceBaseTrackedI[];
  discountsIsSet: boolean;
  /**
   *
   * @type {Array<LineItemRefundBase>}
   * @memberof LineItemFull
   */
  refunds?: LineItemRefundBaseTrackedI[];
  refundsIsSet: boolean;
}

transformDatesMap.set("LineItemFull", function (model: LineItemFull) {
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
  const transformDatesparentItemId = transformDatesMap.get("LineItemRef");
  if (transformDatesparentItemId && model.parentItemId) {
    transformDatesparentItemId(model.parentItemId);
  }
  const transformDatesitemInstanceId = transformDatesMap.get("ItemInstanceRef");
  if (transformDatesitemInstanceId && model.itemInstanceId) {
    transformDatesitemInstanceId(model.itemInstanceId);
  }
  const transformDatessubscriptionId = transformDatesMap.get(
    "PersonSubscriptionRef",
  );
  if (transformDatessubscriptionId && model.subscriptionId) {
    transformDatessubscriptionId(model.subscriptionId);
  }
  const transformDatesclassSignup = transformDatesMap.get("ApClassSignupFull");
  if (transformDatesclassSignup && model.classSignup) {
    transformDatesclassSignup(model.classSignup);
  }
  const transformDatesmembership = transformDatesMap.get("MembershipFull");
  if (transformDatesmembership && model.membership) {
    transformDatesmembership(model.membership);
  }
  const transformDatesdonation = transformDatesMap.get("DonationFull");
  if (transformDatesdonation && model.donation) {
    transformDatesdonation(model.donation);
  }
  const transformDatescard = transformDatesMap.get("CardFull");
  if (transformDatescard && model.card) {
    transformDatescard(model.card);
  }
  const transformDatesgiftCard = transformDatesMap.get(
    "BalanceTransactionFull",
  );
  if (transformDatesgiftCard && model.giftCard) {
    transformDatesgiftCard(model.giftCard);
  }
  const transformDatesguestPrivs = transformDatesMap.get("GuestPrivsFull");
  if (transformDatesguestPrivs && model.guestPrivs) {
    transformDatesguestPrivs(model.guestPrivs);
  }
  const transformDatesdamageWaiver = transformDatesMap.get("DamageWaiverFull");
  if (transformDatesdamageWaiver && model.damageWaiver) {
    transformDatesdamageWaiver(model.damageWaiver);
  }
  const transformDatesstockChange = transformDatesMap.get(
    "ItemInstanceStockChangeBase",
  );
  if (transformDatesstockChange && model.stockChange) {
    transformDatesstockChange(model.stockChange);
  }
  const transformDatespurchaseDelivery = transformDatesMap.get(
    "PurchaseDeliveryRef",
  );
  if (transformDatespurchaseDelivery && model.purchaseDelivery) {
    transformDatespurchaseDelivery(model.purchaseDelivery);
  }
  const transformDatesappliedTaxes = transformDatesMap.get("LineItemTaxBase");
  if (transformDatesappliedTaxes) {
    model.appliedTaxes?.forEach((sub) => {
      transformDatesappliedTaxes(sub);
    });
  }
  const transformDatesdiscounts = transformDatesMap.get(
    "LineItemDiscountInstanceBase",
  );
  if (transformDatesdiscounts) {
    model.discounts?.forEach((sub) => {
      transformDatesdiscounts(sub);
    });
  }
  const transformDatesrefunds = transformDatesMap.get("LineItemRefundBase");
  if (transformDatesrefunds) {
    model.refunds?.forEach((sub) => {
      transformDatesrefunds(sub);
    });
  }
});

export type LineItemFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSpecifiedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  autoAdded: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  squareLineItemUid: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referenceId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  parentItemId: PropertyMeta<LineItemRefMetaI>;
  //isDate: false
  //isDatetime: false
  itemInstanceId: PropertyMeta<ItemInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  subscriptionId: PropertyMeta<PersonSubscriptionRefMetaI>;
  //isDate: false
  //isDatetime: false
  classSignup: PropertyMeta<ApClassSignupFullMetaI>;
  //isDate: false
  //isDatetime: false
  membership: PropertyMeta<MembershipFullMetaI>;
  //isDate: false
  //isDatetime: false
  donation: PropertyMeta<DonationFullMetaI>;
  //isDate: false
  //isDatetime: false
  card: PropertyMeta<CardFullMetaI>;
  //isDate: false
  //isDatetime: false
  giftCard: PropertyMeta<BalanceTransactionFullMetaI>;
  //isDate: false
  //isDatetime: false
  guestPrivs: PropertyMeta<GuestPrivsFullMetaI>;
  //isDate: false
  //isDatetime: false
  damageWaiver: PropertyMeta<DamageWaiverFullMetaI>;
  //isDate: false
  //isDatetime: false
  stockChange: PropertyMeta<ItemInstanceStockChangeBaseMetaI>;
  //isDate: false
  //isDatetime: false
  purchaseDelivery: PropertyMeta<PurchaseDeliveryRefMetaI>;
  //isDate: false
  //isDatetime: false
  appliedTaxes: PropertyMeta<LineItemTaxBaseMetaI>;
  //isDate: false
  //isDatetime: false
  discounts: PropertyMeta<LineItemDiscountInstanceBaseMetaI>;
  //isDate: false
  //isDatetime: false
  refunds: PropertyMeta<LineItemRefundBaseMetaI>;
}>;

export var LineItemFullMeta: LineItemFullMetaI = {} as LineItemFullMetaI;
LineItemFullMeta = typeMeta("LineItemFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  amountSpecifiedCents: propertyMeta(
    "amountSpecifiedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  autoAdded: propertyMeta(
    "autoAdded",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  squareLineItemUid: propertyMeta(
    "squareLineItemUid",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referenceId: propertyMeta(
    "referenceId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  parentItemId: propertyMeta(
    "parentItemId",
    false,
    false,
    false,
    LineItemRefMeta,
  ),
  itemInstanceId: propertyMeta(
    "itemInstanceId",
    false,
    true,
    false,
    ItemInstanceRefMeta,
  ),
  subscriptionId: propertyMeta(
    "subscriptionId",
    false,
    false,
    false,
    PersonSubscriptionRefMeta,
  ),
  classSignup: propertyMeta(
    "classSignup",
    false,
    false,
    false,
    ApClassSignupFullMeta,
  ),
  membership: propertyMeta(
    "membership",
    false,
    false,
    false,
    MembershipFullMeta,
  ),
  donation: propertyMeta("donation", false, false, false, DonationFullMeta),
  card: propertyMeta("card", false, false, false, CardFullMeta),
  giftCard: propertyMeta(
    "giftCard",
    false,
    false,
    false,
    BalanceTransactionFullMeta,
  ),
  guestPrivs: propertyMeta(
    "guestPrivs",
    false,
    false,
    false,
    GuestPrivsFullMeta,
  ),
  damageWaiver: propertyMeta(
    "damageWaiver",
    false,
    false,
    false,
    DamageWaiverFullMeta,
  ),
  stockChange: propertyMeta(
    "stockChange",
    false,
    false,
    false,
    ItemInstanceStockChangeBaseMeta,
  ),
  purchaseDelivery: propertyMeta(
    "purchaseDelivery",
    false,
    false,
    false,
    PurchaseDeliveryRefMeta,
  ),
  appliedTaxes: propertyMeta(
    "appliedTaxes",
    true,
    false,
    false,
    LineItemTaxBaseMeta,
  ),
  discounts: propertyMeta(
    "discounts",
    true,
    false,
    false,
    LineItemDiscountInstanceBaseMeta,
  ),
  refunds: propertyMeta("refunds", true, false, false, LineItemRefundBaseMeta),
});

const metaI = LineItemFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([LineItemBaseMeta]);
  metaI.amountBaseCents.inheritedFrom = LineItemBaseMeta.amountBaseCents;
  metaI.amountSpecifiedCents.inheritedFrom =
    LineItemBaseMeta.amountSpecifiedCents;
  metaI.amountPaidCents.inheritedFrom = LineItemBaseMeta.amountPaidCents;
  metaI.amountSubtotalCents.inheritedFrom =
    LineItemBaseMeta.amountSubtotalCents;
  metaI.amountTotalCents.inheritedFrom = LineItemBaseMeta.amountTotalCents;
  metaI.autoAdded.inheritedFrom = LineItemBaseMeta.autoAdded;
  metaI.squareLineItemUid.inheritedFrom = LineItemBaseMeta.squareLineItemUid;
  metaI.interfaces = metaI.interfaces.concat([LineItemWithExpiresOnRefMeta]);
  metaI.expiresOn.inheritedFrom = LineItemWithExpiresOnRefMeta.expiresOn;
  metaI.assignId.inheritedFrom = LineItemWithExpiresOnRefMeta.assignId;
  metaI.referenceId.inheritedFrom = LineItemWithExpiresOnRefMeta.referenceId;
});

export class LineItemFullTracked
  extends DeletableTracked
  implements LineItemFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountSpecifiedCents__I?: number = undefined;
  amountSpecifiedCentsIsSet: boolean = false;
  set amountSpecifiedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSpecifiedCents__I = v;
      this.amountSpecifiedCentsIsSet = true;
    } else {
      this.amountSpecifiedCents__I = v || undefined;
      this.amountSpecifiedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSpecifiedCents() {
    return this.amountSpecifiedCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  autoAdded__I?: boolean = undefined;
  autoAddedIsSet: boolean = false;
  set autoAdded(v: undefined | boolean) {
    if (v !== undefined) {
      this.autoAdded__I = v;
      this.autoAddedIsSet = true;
    } else {
      this.autoAdded__I = v || undefined;
      this.autoAddedIsSet = false;
    }
    this.changeTracker = true;
  }
  get autoAdded() {
    return this.autoAdded__I;
  }
  squareLineItemUid__I?: string = undefined;
  squareLineItemUidIsSet: boolean = false;
  set squareLineItemUid(v: undefined | string) {
    if (v !== undefined) {
      this.squareLineItemUid__I = v;
      this.squareLineItemUidIsSet = true;
    } else {
      this.squareLineItemUid__I = v || undefined;
      this.squareLineItemUidIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareLineItemUid() {
    return this.squareLineItemUid__I;
  }
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referenceId__I?: string = undefined;
  referenceIdIsSet: boolean = false;
  set referenceId(v: undefined | string) {
    if (v !== undefined) {
      this.referenceId__I = v;
      this.referenceIdIsSet = true;
    } else {
      this.referenceId__I = v || undefined;
      this.referenceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get referenceId() {
    return this.referenceId__I;
  }
  parentItemId__I?: LineItemRefTracked = undefined;
  parentItemIdIsSet: boolean = false;
  set parentItemId(v: undefined | LineItemRefTracked) {
    if (v !== undefined) {
      this.parentItemId__I = v;
      this.parentItemIdIsSet = true;
    } else {
      this.parentItemId__I = v || undefined;
      this.parentItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get parentItemId() {
    return this.parentItemId__I;
  }
  itemInstanceId__I?: ItemInstanceRefTracked = undefined;
  itemInstanceIdIsSet: boolean = false;
  set itemInstanceId(v: undefined | ItemInstanceRefTracked) {
    if (v !== undefined) {
      this.itemInstanceId__I = v;
      this.itemInstanceIdIsSet = true;
    } else {
      this.itemInstanceId__I = v || undefined;
      this.itemInstanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get itemInstanceId() {
    return this.itemInstanceId__I;
  }
  subscriptionId__I?: PersonSubscriptionRefTracked = undefined;
  subscriptionIdIsSet: boolean = false;
  set subscriptionId(v: undefined | PersonSubscriptionRefTracked) {
    if (v !== undefined) {
      this.subscriptionId__I = v;
      this.subscriptionIdIsSet = true;
    } else {
      this.subscriptionId__I = v || undefined;
      this.subscriptionIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get subscriptionId() {
    return this.subscriptionId__I;
  }
  classSignup__I?: ApClassSignupFullTracked = undefined;
  classSignupIsSet: boolean = false;
  set classSignup(v: undefined | ApClassSignupFullTracked) {
    if (v !== undefined) {
      this.classSignup__I = v;
      this.classSignupIsSet = true;
    } else {
      this.classSignup__I = v || undefined;
      this.classSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get classSignup() {
    return this.classSignup__I;
  }
  membership__I?: MembershipFullTracked = undefined;
  membershipIsSet: boolean = false;
  set membership(v: undefined | MembershipFullTracked) {
    if (v !== undefined) {
      this.membership__I = v;
      this.membershipIsSet = true;
    } else {
      this.membership__I = v || undefined;
      this.membershipIsSet = false;
    }
    this.changeTracker = true;
  }
  get membership() {
    return this.membership__I;
  }
  donation__I?: DonationFullTracked = undefined;
  donationIsSet: boolean = false;
  set donation(v: undefined | DonationFullTracked) {
    if (v !== undefined) {
      this.donation__I = v;
      this.donationIsSet = true;
    } else {
      this.donation__I = v || undefined;
      this.donationIsSet = false;
    }
    this.changeTracker = true;
  }
  get donation() {
    return this.donation__I;
  }
  card__I?: CardFullTracked = undefined;
  cardIsSet: boolean = false;
  set card(v: undefined | CardFullTracked) {
    if (v !== undefined) {
      this.card__I = v;
      this.cardIsSet = true;
    } else {
      this.card__I = v || undefined;
      this.cardIsSet = false;
    }
    this.changeTracker = true;
  }
  get card() {
    return this.card__I;
  }
  giftCard__I?: BalanceTransactionFullTracked = undefined;
  giftCardIsSet: boolean = false;
  set giftCard(v: undefined | BalanceTransactionFullTracked) {
    if (v !== undefined) {
      this.giftCard__I = v;
      this.giftCardIsSet = true;
    } else {
      this.giftCard__I = v || undefined;
      this.giftCardIsSet = false;
    }
    this.changeTracker = true;
  }
  get giftCard() {
    return this.giftCard__I;
  }
  guestPrivs__I?: GuestPrivsFullTracked = undefined;
  guestPrivsIsSet: boolean = false;
  set guestPrivs(v: undefined | GuestPrivsFullTracked) {
    if (v !== undefined) {
      this.guestPrivs__I = v;
      this.guestPrivsIsSet = true;
    } else {
      this.guestPrivs__I = v || undefined;
      this.guestPrivsIsSet = false;
    }
    this.changeTracker = true;
  }
  get guestPrivs() {
    return this.guestPrivs__I;
  }
  damageWaiver__I?: DamageWaiverFullTracked = undefined;
  damageWaiverIsSet: boolean = false;
  set damageWaiver(v: undefined | DamageWaiverFullTracked) {
    if (v !== undefined) {
      this.damageWaiver__I = v;
      this.damageWaiverIsSet = true;
    } else {
      this.damageWaiver__I = v || undefined;
      this.damageWaiverIsSet = false;
    }
    this.changeTracker = true;
  }
  get damageWaiver() {
    return this.damageWaiver__I;
  }
  stockChange__I?: ItemInstanceStockChangeBaseTracked = undefined;
  stockChangeIsSet: boolean = false;
  set stockChange(v: undefined | ItemInstanceStockChangeBaseTracked) {
    if (v !== undefined) {
      this.stockChange__I = v;
      this.stockChangeIsSet = true;
    } else {
      this.stockChange__I = v || undefined;
      this.stockChangeIsSet = false;
    }
    this.changeTracker = true;
  }
  get stockChange() {
    return this.stockChange__I;
  }
  purchaseDelivery__I?: PurchaseDeliveryRefTracked = undefined;
  purchaseDeliveryIsSet: boolean = false;
  set purchaseDelivery(v: undefined | PurchaseDeliveryRefTracked) {
    if (v !== undefined) {
      this.purchaseDelivery__I = v;
      this.purchaseDeliveryIsSet = true;
    } else {
      this.purchaseDelivery__I = v || undefined;
      this.purchaseDeliveryIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDelivery() {
    return this.purchaseDelivery__I;
  }
  appliedTaxes__I?: LineItemTaxBaseTracked[] = undefined;
  appliedTaxesIsSet: boolean = false;
  set appliedTaxes(v: undefined | LineItemTaxBaseTracked[]) {
    if (v !== undefined) {
      this.appliedTaxes__I = v;
      this.appliedTaxesIsSet = true;
    } else {
      this.appliedTaxes__I = v || undefined;
      this.appliedTaxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get appliedTaxes() {
    return this.appliedTaxes__I;
  }
  discounts__I?: LineItemDiscountInstanceBaseTracked[] = undefined;
  discountsIsSet: boolean = false;
  set discounts(v: undefined | LineItemDiscountInstanceBaseTracked[]) {
    if (v !== undefined) {
      this.discounts__I = v;
      this.discountsIsSet = true;
    } else {
      this.discounts__I = v || undefined;
      this.discountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get discounts() {
    return this.discounts__I;
  }
  refunds__I?: LineItemRefundBaseTracked[] = undefined;
  refundsIsSet: boolean = false;
  set refunds(v: undefined | LineItemRefundBaseTracked[]) {
    if (v !== undefined) {
      this.refunds__I = v;
      this.refundsIsSet = true;
    } else {
      this.refunds__I = v || undefined;
      this.refundsIsSet = false;
    }
    this.changeTracker = true;
  }
  get refunds() {
    return this.refunds__I;
  }
  constructor(config?: LineItemFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.referenceIdIsSet == true && other?.referenceIdIsSet == true)
      return this.referenceId == other.referenceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.parentItemId?.setIds();

    this.itemInstanceId?.setIds();

    this.subscriptionId?.setIds();

    this.classSignup?.setIds();

    this.membership?.setIds();

    this.donation?.setIds();

    this.card?.setIds();

    this.giftCard?.setIds();

    this.guestPrivs?.setIds();

    this.damageWaiver?.setIds();

    this.stockChange?.setIds();

    this.purchaseDelivery?.setIds();

    this.appliedTaxes?.forEach((a) => a.setIds());

    this.discounts?.forEach((a) => a.setIds());

    this.refunds?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: LineItemFullOptional,
    options?: AssignOptions,
  ): LineItemFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountSpecifiedCents &&
      this.amountSpecifiedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSpecifiedCents = config.amountSpecifiedCents;
      if (optionsRequired.unassign) this.amountSpecifiedCentsIsSet = false;
      else this.amountSpecifiedCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (config.autoAdded && this.autoAddedApplyFilter(optionsRequired.filter)) {
      this.autoAdded = config.autoAdded;
      if (optionsRequired.unassign) this.autoAddedIsSet = false;
      else this.autoAddedIsSet = true;
    }
    if (
      config.squareLineItemUid &&
      this.squareLineItemUidApplyFilter(optionsRequired.filter)
    ) {
      this.squareLineItemUid = config.squareLineItemUid;
      if (optionsRequired.unassign) this.squareLineItemUidIsSet = false;
      else this.squareLineItemUidIsSet = true;
    }
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referenceId &&
      this.referenceIdApplyFilter(optionsRequired.filter)
    ) {
      this.referenceId = config.referenceId;
      if (optionsRequired.unassign) this.referenceIdIsSet = false;
      else this.referenceIdIsSet = true;
    }
    if (
      config.parentItemId &&
      this.parentItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.parentItemId = new LineItemRefTracked(config.parentItemId, options);
      if (optionsRequired.unassign) this.parentItemIdIsSet = false;
      else this.parentItemIdIsSet = true;
    }
    if (
      config.itemInstanceId &&
      this.itemInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.itemInstanceId = new ItemInstanceRefTracked(
        config.itemInstanceId,
        options,
      );
      if (optionsRequired.unassign) this.itemInstanceIdIsSet = false;
      else this.itemInstanceIdIsSet = true;
    }
    if (
      config.subscriptionId &&
      this.subscriptionIdApplyFilter(optionsRequired.filter)
    ) {
      this.subscriptionId = new PersonSubscriptionRefTracked(
        config.subscriptionId,
        options,
      );
      if (optionsRequired.unassign) this.subscriptionIdIsSet = false;
      else this.subscriptionIdIsSet = true;
    }
    if (
      config.classSignup &&
      this.classSignupApplyFilter(optionsRequired.filter)
    ) {
      this.classSignup = new ApClassSignupFullTracked(
        config.classSignup,
        options,
      );
      if (optionsRequired.unassign) this.classSignupIsSet = false;
      else this.classSignupIsSet = true;
    }
    if (
      config.membership &&
      this.membershipApplyFilter(optionsRequired.filter)
    ) {
      this.membership = new MembershipFullTracked(config.membership, options);
      if (optionsRequired.unassign) this.membershipIsSet = false;
      else this.membershipIsSet = true;
    }
    if (config.donation && this.donationApplyFilter(optionsRequired.filter)) {
      this.donation = new DonationFullTracked(config.donation, options);
      if (optionsRequired.unassign) this.donationIsSet = false;
      else this.donationIsSet = true;
    }
    if (config.card && this.cardApplyFilter(optionsRequired.filter)) {
      this.card = new CardFullTracked(config.card, options);
      if (optionsRequired.unassign) this.cardIsSet = false;
      else this.cardIsSet = true;
    }
    if (config.giftCard && this.giftCardApplyFilter(optionsRequired.filter)) {
      this.giftCard = new BalanceTransactionFullTracked(
        config.giftCard,
        options,
      );
      if (optionsRequired.unassign) this.giftCardIsSet = false;
      else this.giftCardIsSet = true;
    }
    if (
      config.guestPrivs &&
      this.guestPrivsApplyFilter(optionsRequired.filter)
    ) {
      this.guestPrivs = new GuestPrivsFullTracked(config.guestPrivs, options);
      if (optionsRequired.unassign) this.guestPrivsIsSet = false;
      else this.guestPrivsIsSet = true;
    }
    if (
      config.damageWaiver &&
      this.damageWaiverApplyFilter(optionsRequired.filter)
    ) {
      this.damageWaiver = new DamageWaiverFullTracked(
        config.damageWaiver,
        options,
      );
      if (optionsRequired.unassign) this.damageWaiverIsSet = false;
      else this.damageWaiverIsSet = true;
    }
    if (
      config.stockChange &&
      this.stockChangeApplyFilter(optionsRequired.filter)
    ) {
      this.stockChange = new ItemInstanceStockChangeBaseTracked(
        config.stockChange,
        options,
      );
      if (optionsRequired.unassign) this.stockChangeIsSet = false;
      else this.stockChangeIsSet = true;
    }
    if (
      config.purchaseDelivery &&
      this.purchaseDeliveryApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDelivery = new PurchaseDeliveryRefTracked(
        config.purchaseDelivery,
        options,
      );
      if (optionsRequired.unassign) this.purchaseDeliveryIsSet = false;
      else this.purchaseDeliveryIsSet = true;
    }
    if (
      config.appliedTaxes &&
      this.appliedTaxesApplyFilter(optionsRequired.filter)
    ) {
      this.appliedTaxes = config.appliedTaxes?.map(
        (a) => new LineItemTaxBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.appliedTaxesIsSet = false;
      else this.appliedTaxesIsSet = true;
    }
    if (config.discounts && this.discountsApplyFilter(optionsRequired.filter)) {
      this.discounts = config.discounts?.map(
        (a) => new LineItemDiscountInstanceBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.discountsIsSet = false;
      else this.discountsIsSet = true;
    }
    if (config.refunds && this.refundsApplyFilter(optionsRequired.filter)) {
      this.refunds = config.refunds?.map(
        (a) => new LineItemRefundBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.refundsIsSet = false;
      else this.refundsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemFullTrackedI {
    const cloned = {} as LineItemFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountSpecifiedCentsIsSetDeep() &&
      this.amountSpecifiedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSpecifiedCentsIsSet = true;
      cloned.amountSpecifiedCents = this.amountSpecifiedCents;
    } else {
      //cloned.amountSpecifiedCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.autoAddedIsSetDeep() &&
      this.autoAddedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.autoAddedIsSet = true;
      cloned.autoAdded = this.autoAdded;
    } else {
      //cloned.autoAddedIsSet = false
    }
    if (
      this.squareLineItemUidIsSetDeep() &&
      this.squareLineItemUidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareLineItemUidIsSet = true;
      cloned.squareLineItemUid = this.squareLineItemUid;
    } else {
      //cloned.squareLineItemUidIsSet = false
    }
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referenceIdIsSetDeep() &&
      this.referenceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referenceIdIsSet = true;
      cloned.referenceId = this.referenceId;
    } else {
      //cloned.referenceIdIsSet = false
    }
    if (
      this.parentItemIdIsSetDeep() &&
      this.parentItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.parentItemIdIsSet = true;
      cloned.parentItemId = this.parentItemId?.removeUnset(filter);
    } else {
      //cloned.parentItemIdIsSet = false
    }
    if (
      this.itemInstanceIdIsSetDeep() &&
      this.itemInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemInstanceIdIsSet = true;
      cloned.itemInstanceId = this.itemInstanceId?.removeUnset(filter);
    } else {
      //cloned.itemInstanceIdIsSet = false
    }
    if (
      this.subscriptionIdIsSetDeep() &&
      this.subscriptionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.subscriptionIdIsSet = true;
      cloned.subscriptionId = this.subscriptionId?.removeUnset(filter);
    } else {
      //cloned.subscriptionIdIsSet = false
    }
    if (
      this.classSignupIsSetDeep() &&
      this.classSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classSignupIsSet = true;
      cloned.classSignup = this.classSignup?.removeUnset(filter);
    } else {
      //cloned.classSignupIsSet = false
    }
    if (
      this.membershipIsSetDeep() &&
      this.membershipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipIsSet = true;
      cloned.membership = this.membership?.removeUnset(filter);
    } else {
      //cloned.membershipIsSet = false
    }
    if (
      this.donationIsSetDeep() &&
      this.donationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationIsSet = true;
      cloned.donation = this.donation?.removeUnset(filter);
    } else {
      //cloned.donationIsSet = false
    }
    if (
      this.cardIsSetDeep() &&
      this.cardApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardIsSet = true;
      cloned.card = this.card?.removeUnset(filter);
    } else {
      //cloned.cardIsSet = false
    }
    if (
      this.giftCardIsSetDeep() &&
      this.giftCardApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.giftCardIsSet = true;
      cloned.giftCard = this.giftCard?.removeUnset(filter);
    } else {
      //cloned.giftCardIsSet = false
    }
    if (
      this.guestPrivsIsSetDeep() &&
      this.guestPrivsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.guestPrivsIsSet = true;
      cloned.guestPrivs = this.guestPrivs?.removeUnset(filter);
    } else {
      //cloned.guestPrivsIsSet = false
    }
    if (
      this.damageWaiverIsSetDeep() &&
      this.damageWaiverApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.damageWaiverIsSet = true;
      cloned.damageWaiver = this.damageWaiver?.removeUnset(filter);
    } else {
      //cloned.damageWaiverIsSet = false
    }
    if (
      this.stockChangeIsSetDeep() &&
      this.stockChangeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stockChangeIsSet = true;
      cloned.stockChange = this.stockChange?.removeUnset(filter);
    } else {
      //cloned.stockChangeIsSet = false
    }
    if (
      this.purchaseDeliveryIsSetDeep() &&
      this.purchaseDeliveryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDeliveryIsSet = true;
      cloned.purchaseDelivery = this.purchaseDelivery?.removeUnset(filter);
    } else {
      //cloned.purchaseDeliveryIsSet = false
    }
    if (
      this.appliedTaxesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.appliedTaxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.appliedTaxesIsSet = true;
      cloned.appliedTaxes = this.appliedTaxes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.appliedTaxesIsSet = false
    }
    if (
      this.discountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.discountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountsIsSet = true;
      cloned.discounts = this.discounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.discountsIsSet = false
    }
    if (
      this.refundsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.refundsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.refundsIsSet = true;
      cloned.refunds = this.refunds
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.refundsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountSpecifiedCentsApplyFilter(filter))
      this.amountSpecifiedCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.autoAddedApplyFilter(filter)) this.autoAddedIsSet = false;

    if (!this.squareLineItemUidApplyFilter(filter))
      this.squareLineItemUidIsSet = false;

    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referenceIdApplyFilter(filter)) this.referenceIdIsSet = false;

    if (!this.parentItemIdApplyFilter(filter)) this.parentItemIdIsSet = false;
    this.parentItemId?.unassignAll(filter);

    if (!this.itemInstanceIdApplyFilter(filter))
      this.itemInstanceIdIsSet = false;
    this.itemInstanceId?.unassignAll(filter);

    if (!this.subscriptionIdApplyFilter(filter))
      this.subscriptionIdIsSet = false;
    this.subscriptionId?.unassignAll(filter);

    if (!this.classSignupApplyFilter(filter)) this.classSignupIsSet = false;
    this.classSignup?.unassignAll(filter);

    if (!this.membershipApplyFilter(filter)) this.membershipIsSet = false;
    this.membership?.unassignAll(filter);

    if (!this.donationApplyFilter(filter)) this.donationIsSet = false;
    this.donation?.unassignAll(filter);

    if (!this.cardApplyFilter(filter)) this.cardIsSet = false;
    this.card?.unassignAll(filter);

    if (!this.giftCardApplyFilter(filter)) this.giftCardIsSet = false;
    this.giftCard?.unassignAll(filter);

    if (!this.guestPrivsApplyFilter(filter)) this.guestPrivsIsSet = false;
    this.guestPrivs?.unassignAll(filter);

    if (!this.damageWaiverApplyFilter(filter)) this.damageWaiverIsSet = false;
    this.damageWaiver?.unassignAll(filter);

    if (!this.stockChangeApplyFilter(filter)) this.stockChangeIsSet = false;
    this.stockChange?.unassignAll(filter);

    if (!this.purchaseDeliveryApplyFilter(filter))
      this.purchaseDeliveryIsSet = false;
    this.purchaseDelivery?.unassignAll(filter);

    if (!this.appliedTaxesApplyFilter(filter)) this.appliedTaxesIsSet = false;

    this.appliedTaxes?.forEach((a) => a.unassignAll(filter));
    if (!this.discountsApplyFilter(filter)) this.discountsIsSet = false;

    this.discounts?.forEach((a) => a.unassignAll(filter));
    if (!this.refundsApplyFilter(filter)) this.refundsIsSet = false;

    this.refunds?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.isDeleted,
      LineItemFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(LineItemFullMeta.isNew, LineItemFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.amountBaseCents,
      LineItemFullMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSpecifiedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.amountSpecifiedCents,
      LineItemFullMeta,
      this.amountSpecifiedCents,
      this,
    );
  }
  amountSpecifiedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSpecifiedCentsIsSet &&
      this.amountSpecifiedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.amountPaidCents,
      LineItemFullMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.amountSubtotalCents,
      LineItemFullMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.amountTotalCents,
      LineItemFullMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  autoAddedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.autoAdded,
      LineItemFullMeta,
      this.autoAdded,
      this,
    );
  }
  autoAddedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.autoAddedIsSet && this.autoAddedApplyFilter(filter)) return true;

    return false;
  }
  squareLineItemUidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.squareLineItemUid,
      LineItemFullMeta,
      this.squareLineItemUid,
      this,
    );
  }
  squareLineItemUidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.squareLineItemUidIsSet &&
      this.squareLineItemUidApplyFilter(filter)
    )
      return true;

    return false;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.expiresOn,
      LineItemFullMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.assignId,
      LineItemFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referenceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.referenceId,
      LineItemFullMeta,
      this.referenceId,
      this,
    );
  }
  referenceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referenceIdIsSet && this.referenceIdApplyFilter(filter))
      return true;

    return false;
  }
  parentItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.parentItemId,
      LineItemFullMeta,
      this.parentItemId,
      this,
    );
  }
  parentItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.parentItemIdIsSet && this.parentItemIdApplyFilter(filter))
      return true;
    return this.parentItemId?.anySet(filter) == true;

    return false;
  }
  itemInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.itemInstanceId,
      LineItemFullMeta,
      this.itemInstanceId,
      this,
    );
  }
  itemInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemInstanceIdIsSet && this.itemInstanceIdApplyFilter(filter))
      return true;
    return this.itemInstanceId?.anySet(filter) == true;

    return false;
  }
  subscriptionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.subscriptionId,
      LineItemFullMeta,
      this.subscriptionId,
      this,
    );
  }
  subscriptionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.subscriptionIdIsSet && this.subscriptionIdApplyFilter(filter))
      return true;
    return this.subscriptionId?.anySet(filter) == true;

    return false;
  }
  classSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.classSignup,
      LineItemFullMeta,
      this.classSignup,
      this,
    );
  }
  classSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classSignupIsSet && this.classSignupApplyFilter(filter))
      return true;
    return this.classSignup?.anySet(filter) == true;

    return false;
  }
  membershipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.membership,
      LineItemFullMeta,
      this.membership,
      this,
    );
  }
  membershipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipIsSet && this.membershipApplyFilter(filter)) return true;
    return this.membership?.anySet(filter) == true;

    return false;
  }
  donationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.donation,
      LineItemFullMeta,
      this.donation,
      this,
    );
  }
  donationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationIsSet && this.donationApplyFilter(filter)) return true;
    return this.donation?.anySet(filter) == true;

    return false;
  }
  cardApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(LineItemFullMeta.card, LineItemFullMeta, this.card, this);
  }
  cardIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardIsSet && this.cardApplyFilter(filter)) return true;
    return this.card?.anySet(filter) == true;

    return false;
  }
  giftCardApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.giftCard,
      LineItemFullMeta,
      this.giftCard,
      this,
    );
  }
  giftCardIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.giftCardIsSet && this.giftCardApplyFilter(filter)) return true;
    return this.giftCard?.anySet(filter) == true;

    return false;
  }
  guestPrivsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.guestPrivs,
      LineItemFullMeta,
      this.guestPrivs,
      this,
    );
  }
  guestPrivsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.guestPrivsIsSet && this.guestPrivsApplyFilter(filter)) return true;
    return this.guestPrivs?.anySet(filter) == true;

    return false;
  }
  damageWaiverApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.damageWaiver,
      LineItemFullMeta,
      this.damageWaiver,
      this,
    );
  }
  damageWaiverIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.damageWaiverIsSet && this.damageWaiverApplyFilter(filter))
      return true;
    return this.damageWaiver?.anySet(filter) == true;

    return false;
  }
  stockChangeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.stockChange,
      LineItemFullMeta,
      this.stockChange,
      this,
    );
  }
  stockChangeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stockChangeIsSet && this.stockChangeApplyFilter(filter))
      return true;
    return this.stockChange?.anySet(filter) == true;

    return false;
  }
  purchaseDeliveryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.purchaseDelivery,
      LineItemFullMeta,
      this.purchaseDelivery,
      this,
    );
  }
  purchaseDeliveryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDeliveryIsSet && this.purchaseDeliveryApplyFilter(filter))
      return true;
    return this.purchaseDelivery?.anySet(filter) == true;

    return false;
  }
  appliedTaxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.appliedTaxes,
      LineItemFullMeta,
      this.appliedTaxes,
      this,
    );
  }
  appliedTaxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.appliedTaxesIsSet && this.appliedTaxesApplyFilter(filter))
      return true;

    return this.appliedTaxes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  discountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.discounts,
      LineItemFullMeta,
      this.discounts,
      this,
    );
  }
  discountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountsIsSet && this.discountsApplyFilter(filter)) return true;

    return this.discounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  refundsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemFullMeta.refunds,
      LineItemFullMeta,
      this.refunds,
      this,
    );
  }
  refundsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.refundsIsSet && this.refundsApplyFilter(filter)) return true;

    return this.refunds?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountSpecifiedCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.autoAddedIsSetDeep(filter)) return true;
    if (this.squareLineItemUidIsSetDeep(filter)) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referenceIdIsSetDeep(filter)) return true;
    if (this.parentItemIdIsSetDeep(filter)) return true;
    if (this.itemInstanceIdIsSetDeep(filter)) return true;
    if (this.subscriptionIdIsSetDeep(filter)) return true;
    if (this.classSignupIsSetDeep(filter)) return true;
    if (this.membershipIsSetDeep(filter)) return true;
    if (this.donationIsSetDeep(filter)) return true;
    if (this.cardIsSetDeep(filter)) return true;
    if (this.giftCardIsSetDeep(filter)) return true;
    if (this.guestPrivsIsSetDeep(filter)) return true;
    if (this.damageWaiverIsSetDeep(filter)) return true;
    if (this.stockChangeIsSetDeep(filter)) return true;
    if (this.purchaseDeliveryIsSetDeep(filter)) return true;
    if (this.appliedTaxesIsSetDeep(filter)) return true;
    if (this.discountsIsSetDeep(filter)) return true;
    if (this.refundsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
